import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import { Document, Page, pdfjs } from 'react-pdf'
pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.js', import.meta.url).toString()

import './GammelGrunnbokViewer.scss'

class GammelGrunnbokViewer extends Component {
    state = {
        pageCount: 1,
        pageNumber: 1,
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.gammelGrunnbok != null) {
            this.updateSelectedEiendom(this.props.gammelGrunnbok.kommunenummer, this.props.gammelGrunnbok.gardsnummer, this.props.gammelGrunnbok.bruksnummer, this.props.gammelGrunnbok.festenummer, this.props.gammelGrunnbok.seksjonsnummer)
        }
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ pageCount: numPages });
    }

    nextEiendom = () => {
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/neste`, {
            params: {
                token: this.props.token,
                kommunenummer: this.state.kommunenummer,
                gardsnummer: this.state.gardsnummer,
                bruksnummer: this.state.bruksnummer,
                festenummer: this.state.festenummer,
                seksjonsnummer: this.state.seksjonsnummer
            }
        })
        .then(({data}) => {
            if (!data.gardsnummer) return
            this.updateSelectedEiendom(data.kommunenummer, data.gardsnummer, data.bruksnummer, data.festenummer, data.seksjonsnummer)
        })
    }

    previousEiendom = () => {
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/forrige`, {
            params: {
                token: this.props.token,
                kommunenummer: this.state.kommunenummer,
                gardsnummer: this.state.gardsnummer,
                bruksnummer: this.state.bruksnummer,
                festenummer: this.state.festenummer,
                seksjonsnummer: this.state.seksjonsnummer
            }
        })
        .then(({data}) => {
            if (!data.gardsnummer) return
            this.updateSelectedEiendom(data.kommunenummer, data.gardsnummer, data.bruksnummer, data.festenummer, data.seksjonsnummer)
        })
    }

    updateSelectedEiendom = (kommunenummer, gardsnummer, bruksnummer, festenummer, seksjonsnummer) => {
        this.setState({
            kommunenummer: kommunenummer,
            gardsnummer: gardsnummer,
            bruksnummer: bruksnummer,
            festenummer: festenummer,
            seksjonsnummer: seksjonsnummer,
            pageNumber: 1,
            pageCount: 1,
            url: `${this.props.settings.baseUrl}api/grunnbok/gammelgrunnbok?kommunenummer=${kommunenummer}&gardsnummer=${gardsnummer}&bruksnummer=${bruksnummer}&festenummer=${festenummer}&seksjonsnummer=${seksjonsnummer}&token=${this.props.token}`
        })
    }

    nextPage = () => {
        if (this.state.pageNumber >= this.state.pageCount) return
        this.setState({pageNumber: this.state.pageNumber+1})
    }

    previousPage = () => {        
        if (this.state.pageNumber <= 1) return
        this.setState({pageNumber: this.state.pageNumber-1})
    }

    downloadDocument = () => {
        var url = `${this.props.settings.baseUrl}api/grunnbok/gammelgrunnbok?kommunenummer=${this.state.kommunenummer}&gardsnummer=${this.state.gardsnummer}&bruksnummer=${this.state.bruksnummer}&festenummer=${this.state.festenummer}&seksjonsnummer=${this.state.seksjonsnummer}&token=${this.props.token}`
        window.open(url, '_blank')
    }

    exit = () => {
        this.props.onClose()
    }

    render() {
        const { t } = this.props
        return (
            <div className="gammelgrunnbokviewer">
                <div className="toolbar">
                    <div className="column">
                        <div className="toolbar-button" onClick={this.previousEiendom}>
                            <span className="toolbar-icon"><i className={"fa fa-arrow-left fa-fw"}></i></span>
                            <span>{t('forrigeeiendom')}</span>
                        </div>
                        <div className="matrikkelnummer">{`${this.state.kommunenummer}-${this.state.gardsnummer}/${this.state.bruksnummer}/${this.state.festenummer}/${this.state.seksjonsnummer}`}</div>
                        <div className="toolbar-button" onClick={this.nextEiendom}>
                        <span>{t('nesteeiendom')}</span>
                            <span className="toolbar-icon"><i className={"fa fa-arrow-right fa-fw"}></i></span>
                        </div>
                    </div>
                    <div className="column">
                        <div className="toolbar-button" onClick={this.previousPage}>
                            <span className="toolbar-icon"><i className={`fa fa-arrow-up fa-fw${this.state.pageNumber > 1 ? "" : " disabled"}`}></i></span>
                            <span>{t('forrigeside')}</span>
                        </div>
                        <div className="pagenumber">{`${this.state.pageNumber}/${this.state.pageCount}`}</div>
                        <div className="toolbar-button" onClick={this.nextPage}>
                            <span>{t('nesteside')}</span>
                            <span className="toolbar-icon"><i className={`fa fa-arrow-down fa-fw${this.state.pageNumber < this.state.pageCount ? "" : " disabled"}`}></i></span>
                        </div>
                    </div>
                    <div className="column">
                        <div className="toolbar-button" onClick={this.downloadDocument}>
                            <span className="toolbar-icon"><i className={"fa fa-download fa-fw"}></i></span>
                            <span>{t('lastned')}</span>
                        </div>                       
                        <div className="toolbar-button" onClick={this.exit}>
                            <span className="toolbar-icon"><i className={"fa fa-times fa-fw"}></i></span>
                            <span>{t('lukk')}</span>
                        </div>
                    </div>
                </div>
                <Document className="viewer" file={this.state.url} onLoadSuccess={this.onDocumentLoadSuccess} error={<div>{t('ingengammelgrunnbok')}</div>} loading={<div className="document-spinner"><i className="fa fa-spinner fa-spin"></i></div>}>
                    <Page className="page" pageNumber={this.state.pageNumber} scale={2} loading="" renderTextLayer={false} renderAnnotationLayer={false} />
                </Document>
            </div>
        )
    }
}

export default withTranslation('common')(GammelGrunnbokViewer)